import { Component, OnInit, Input } from '@angular/core';
import { STUB_FN_FALSE, STUB_FN_STRING } from 'projects/exi-ui/src/lib/utils/stubs';
import { Fade } from 'projects/exi-ui/src/lib/animations/animations';

@Component({
   selector: 'app-input',
   template: `
      <div *ngIf="message.length"
            class="message"
            @Fade>
         {{ message }}
      </div>
      <input   [type]="ctx.type"
               (change)="isValid()"
               (keyup)="isValid()"
               (blur)="focusOut()"
               (focus)="focus()"
               [(ngModel)]="value"
               class="input"
               [ngClass]="{ 'inValid': message.length }"
               #Input>
      <div  class="placeholder"
            [ngClass]="{'upper': isFocused || message.length }">
         {{ ctx.placeholder }}
      </div>
   `,
   styleUrls: ['./input.component.scss'],
   animations: [ Fade ]
})
export class InputComponent implements OnInit {
   @Input() ctx: Editable;
   public value: string;
   public message: string;
   public isFocused = false;

   constructor() { }

   ngOnInit() {
      this.ctx.isDisabled = this.ctx.isDisabled || STUB_FN_FALSE;
      this.ctx.isValid = this.ctx.isValid || STUB_FN_STRING;
      this.ctx.type = this.ctx.type || 'text';
      this.ctx.isRequired = !!this.ctx.isRequired;
      this.value = this.ctx.get();
      this.isValid();
   }

   public isValid() {
      this.message = this.ctx.isValid(this.value);
      this.ctx.set(this.value);

      console.log(typeof this.value);
   }

   public focus() {
      this.isFocused = true;
   }


   public focusOut() {
      this.isFocused = false;
      if (this.ctx.isRequired && this.value === ``) {
         this.message = `This value is required`;
      }
   }

}


export type InputTypes = 'text' | 'number';

export interface Editable {
   get: () => string;
   set: (val: string) => void;
   type?: InputTypes;
   isValid?: (val: string) => string;
   isDisabled?: () => boolean;
   isRequired?: boolean;
   placeholder: string;
}